import { gql } from '@apollo/client'

const PASSENGER_TYPE_FIELDS = gql`
  fragment PassengerTypeFields on PassengerTypeV2 {
    id
    name
    enabled
    countryCode
    label {
      language
      text
      plural
    }
    abbreviation {
      language
      text
      plural
    }
    description {
      language
      text
      plural
    }
    discount
    salesChannelsV2 {
      id
      name
    }
    createdAt
    updatedAt
  }
`

export const GET_PASSENGER_TYPE = gql`
  query GetPassengerType($input: PassengerTypeInput!) {
    passengerType(input: $input) {
      ...PassengerTypeFields
    }
  }
  ${PASSENGER_TYPE_FIELDS}
`

export const GET_PASSENGER_TYPES = gql`
  query GetPassengerTypes($pagination: Pagination, $input: PassengerTypesInput) {
    passengerTypes(pagination: $pagination, input: $input) {
      items {
        ...PassengerTypeFields
      }
      total
    }
  }
  ${PASSENGER_TYPE_FIELDS}
`

export const GET_PASSENGER_TYPES_AUTOCOMPLETE = gql`
  query GetPassengerTypesAutoComplete($input: PassengerTypesAutocompleteInput) {
    passengerTypesAutocomplete(input: $input) {
      id
      name
      label
      countryCode
    }
  }
`
